import type {AxiosError} from "axios";
import {ResourceException, type ResourceError, ResourceErrorType} from "../types/resourceError";
import {userLogout} from "./authenticationService";

/**
 * Handles error thrown by Axios and rethrows ResourceException
 */
export const handleAxiosError = async (error: AxiosError) => {
    const resourceErrorDetails = getResourceErrorDetails(error);

    if (resourceErrorDetails.type === ResourceErrorType.HTTP_UNAUTHORIZED_ERROR) {
        await userLogout();
        window.location.reload();
    }

    throw new ResourceException(resourceErrorDetails, resourceErrorDetails.message);
};

const getResourceErrorDetails = (error: AxiosError): ResourceError => {
    const statusCode = error.response?.status;

    let errorType: ResourceErrorType;

    if (statusCode === undefined) {
        errorType = ResourceErrorType.UNKNOWN_ERROR;
    } else if (statusCode === 400) {
        errorType = ResourceErrorType.HTTP_BAD_REQUEST_ERROR;
    } else if (statusCode === 401) {
        errorType = ResourceErrorType.HTTP_UNAUTHORIZED_ERROR;
    } else if (statusCode === 403) {
        errorType = ResourceErrorType.HTTP_FORBIDDEN_ERROR;
    } else if (statusCode === 404) {
        errorType = ResourceErrorType.HTTP_NOT_FOUND_ERROR;
    } else if (statusCode >= 500 && statusCode <= 599) {
        errorType = ResourceErrorType.HTTP_SERVER_ERROR;
    } else {
        errorType = ResourceErrorType.HTTP_OTHER_ERROR;
    }

    let message: string | undefined;

    // In case we have an error in reponse use it, otherwise get error.message
    if (error.response?.data) {
        message = (error.response.data as Record<string, string>).error;
    }

    if (!message) {
        message = error.message ?? "Unknown HTTP error";
    }

    return {
        type: errorType,
        message,
    };
};
